export default __webpack_public_path__ + "static/media/Shroud of Zath.d0276280.jpg";